import {
    Button,
    Grid,
    IconButton,
    Tooltip,
    Typography
} from '@mui/material';
import { useTheme } from '@mui/styles';
import { TransactionHistory } from '@tassat/icon';
import { muiTheme } from '@tassat/payments-themes';
import * as React from 'react';

import muiStyles from './styles';
import { ViewTransactionHistoryButtonProps } from './types';

export default function ViewTransactionHistoryButton(props: ViewTransactionHistoryButtonProps) {
    const {
        history,
        text,
        firm,
        account
    } = props;

    const classes = muiStyles(props);

    const theme = useTheme<typeof muiTheme>();

    if (!firm && !account) return <div />;

    const renderTitle = () => {
        if (firm) {
            return 'Firm Transaction History';
        }

        if (account) {
            return 'Account Transaction History';
        }

        return '';
    };

    return (
        <Grid
            className={classes.root}
            container
            direction='row'
            justifyContent='center'
            onClick={() => {
                if (firm) {
                    history?.push('/admin/history', { firmId: firm.FirmId });
                }
                if (account) {
                    history?.push('/admin/history', {
                        firmId: account.FirmId,
                        accountId: account.AccountId
                    });
                }
            }}
            spacing={0}
            wrap='nowrap'
        >
            {text ?
                (
                    <Button>
                        <TransactionHistory
                            className={classes.icon}
                            iconColor={theme?.app?.clientTheme.colors.primaryColor || '#375073'}
                        />
                        <Typography
                            className={classes.linkText}
                            variant='body1'
                        >
                            {text}
                        </Typography>
                    </Button>
                )
                : (
                    <Tooltip
                        disableInteractive
                        title={renderTitle()}
                    >
                        <IconButton className={classes.iconButton}>
                            <TransactionHistory
                                className={classes.icon}
                                iconColor={theme?.app?.clientTheme.colors.primaryColor || '#375073'}
                            />
                        </IconButton>
                    </Tooltip>
                )}
        </Grid>
    );
}